import {
  Box,
  Container,
  VStack,
  HStack,
  Flex,
  Heading,
  Text,
  Button,
  Image,
} from "@chakra-ui/react";

import "./styles.css";
import Card from "../Cards";

import gif from "../../assets/images/Marbleverse NFT (1).gif";

const cardDetails = [
  ["Mint", "0.04ETH"],
  ["Total Supply", "10000"],
  ["Supply Drop #1", "1000"],
];
const index = () => {
  return (
    <Container maxW="container.xl">
      <Box>
        <VStack
          spacing={20}
          textAlign="center"
          my={32}
          h=""
          alignItems="center"
          justify="center"
        >
          <Heading as="h2" size="3xl" textShadow="0px 0px 50px #FFFFFF">
            MARBLEVERSE NFT COLLECTION
          </Heading>
          <Text
            fontSize="xl"
            fontWeight="500"
            px={5}
            textShadow="10px 10px 4px rgba(0, 0, 0, 0.5)"
          >
            First P2E game with a chance to 100x in a day. Simple, fast and
            transparent. Each genesis NFT is a ticket to win $300,000 in prizes.
          </Text>
          {/* <Button
            variant="secondary"
            size="lg"
            borderImage="linear-gradient(180deg, #7A20AB 0%, #BB1984 100%)"
            id=""
          >
            Mint Now
          </Button> */}
          <button id="gButton">Mint Now</button>
          <Image src={gif} />
          {/* <iframe
            width="100%"
            height="315"
            src="https://www.youtube.com/embed/lTIHfK1ZN6I"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
            id="video"
          ></iframe> */}
          <Flex
            width="100%"
            // spacing={8}
            alignItems="center"
            justifyContent="space-between"
            flexDirection={{ base: "column", md: "row" }}
          >
            {cardDetails.map((i) => (
              <Card key={i[0]}>
                <HStack
                  alignItems="center"
                  w="100%"
                  h="100%"
                  justifyContent="space-around"
                >
                  <Text fontSize="xl">{i[0]}</Text>
                  <Text fontSize="4xl">{i[1]}</Text>
                </HStack>
              </Card>
            ))}
          </Flex>
        </VStack>
      </Box>
    </Container>
  );
};
export default index;
